import { memo } from "react";
import { DownloadOutlined, FileTextOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Card, Empty, Space, Typography, Upload } from "antd";
import {
  SHAREPOINT_WSR_FOLDER_URL,
  SHAREPOINT_BASE_PATH,
} from "../../../config/constants";
import DataState from "../../../components/DataState/DataState";


export function WsrReportTabComponent({
  selectedProjectId,
  selectedcustomerName,
  wsrUploadProps,
  wsrUploading,
  currentMonthLabel,
  previousMonthLabel,
  currentWsrFile,
  previousWsrFile,
  wsrLoading,
  onDownloadWsrFile,
}) {
  return (
    <DataState status={wsrLoading ? "loading" : "ready"} skeletonRows={4}>
    <Space direction="vertical" style={{ width: "100%" }} size={16}>
      <Card
        style={{ borderRadius: 14, border: "1px solid #e6ecf5", boxShadow: "0 6px 18px rgba(16,24,40,0.03)" }}
        styles={{ body: { padding: 18 } }}
      >
       <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    marginBottom: 14,
  }}
>
  <div>
    <Typography.Title level={4} style={{ margin: 0 }}>
      WSR Report
    </Typography.Title>

    <Typography.Text type="secondary" style={{ fontSize: 13 }}>
      Only the latest and previous WSR files are retained.
    </Typography.Text>
  </div>

   <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
<Button
  size="small"
  onClick={() => {
    const folderPath =
      `${SHAREPOINT_BASE_PATH}/${selectedcustomerName}/${selectedProjectId}`;

    const params = new URLSearchParams({
      id: folderPath,
      viewid: "b76fb5fd-4843-4df1-b331-e4f399931064",
      sharingv2: "true",
      fromShare: "true",
      at: "9",
      CT: "1781671004850",
      OR: "Teams-HL",
      CID: "ae601ea2-8059-4000-f1c5-746ab3c0283c",
      SI: "NonSentItems",
      FolderCTID: "0x0120000D512C072D4FBF4A8E275B3131F4973E",
    });

    const sharePointUrl =
      `${SHAREPOINT_WSR_FOLDER_URL}?${params.toString()}`;

    window.open(
      sharePointUrl,
      "_blank",
      "noopener,noreferrer",
    );
  }}
>
  Go to SharePoint
</Button>


    <Upload {...wsrUploadProps}>
      <Button
        type="primary"
        size="small"
        icon={<UploadOutlined />}
        style={{width:"auto",height:"auto"}}
        loading={wsrUploading}
      >
        Upload New WSR
      </Button>
    </Upload>
  </div>
</div>

        <Space direction="vertical" style={{ width: "100%" }} size={8}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 10,
              padding: "10px 14px",
              border: "1px solid #e6ecf5",
              borderRadius: 10,
              background: "#f8fbff",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
              <FileTextOutlined style={{ color: "#1677ff" }} />
              <Typography.Text strong style={{ fontSize: 13 }}>
                {currentMonthLabel}
              </Typography.Text>
              {currentWsrFile && (
                <Typography.Text type="secondary" ellipsis style={{ fontSize: 12, maxWidth: 260 }}>
                  {currentWsrFile.fileName}
                </Typography.Text>
              )}
            </div>
            <Button
              size="small"
              icon={<DownloadOutlined />}
              disabled={!currentWsrFile}
              onClick={() => currentWsrFile && onDownloadWsrFile(currentWsrFile)}
            >
              Download
            </Button>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 10,
              padding: "10px 14px",
              border: "1px solid #e6ecf5",
              borderRadius: 10,
              background: "#fff",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
              <FileTextOutlined style={{ color: "#8c8c8c" }} />
              <Typography.Text strong style={{ fontSize: 13 }}>
                {previousMonthLabel}
              </Typography.Text>
              {previousWsrFile && (
                <Typography.Text type="secondary" ellipsis style={{ fontSize: 12, maxWidth: 260 }}>
                  {previousWsrFile.fileName}
                </Typography.Text>
              )}
            </div>
            <Button
              size="small"
              icon={<DownloadOutlined />}
              disabled={!previousWsrFile}
              onClick={() => previousWsrFile && onDownloadWsrFile(previousWsrFile)}
            >
              Download
            </Button>
          </div>
        </Space>

        {!currentWsrFile && !previousWsrFile && (
          <Empty description="No WSR files uploaded yet" style={{ marginTop: 12 }} />
        )}
      </Card>
    </Space>
    </DataState>
  );
}

export const WsrReportTab = memo(WsrReportTabComponent);
